import type { FaireProductEntity } from "../../entity_types/product";

export const p_qdt4n6sxab: FaireProductEntity = {
  token: "p_qdt4n6sxab",
  type: "product",
  name: "DIY Magnesium Oil Spray Kit (No Labels)",
  brandToken: "b_xvt273bhwc",
  brandName: "Herbal Rose Apothecary",
  imageUrl:
    "https://cdn.faire.com/fastly/84d8c3c193dd353e065e64db0b174ee398172801461a797a25dad6cb94fb8a30.jpeg",
  galleryImageUrls: [],
  priceDollars: 12.47,
  description:
    "Let your customers create their own Magnesium oil spray with this DIY kit. Perfect for beginner-friendly apothecaries and workshops. Most shops stock 4–6 units to start & reorder every 6-8 weeks.\nKit includes one 8oz glass spray bottle, 3.8oz magnesium flakes, and step-by-step instructions on how to make your own magnesium oil spray.\n\n*No labels means no branding on products, add your own branded labels to product.\n\nMagnesium oil is made from a mixture of magnesium chloride flakes and water. When these two substances are combined, the resulting liquid has an oily feel but isn’t technically an oil. Applying magnesium oil topically to the skin may help replenish levels of this nutrient within the body, a process known as transdermal.\n\nMagnesium is an important nutrient that has multiple functions within the body and may help with the following:\nregulating nerve and muscle function\npromoting sleep\nskin hydration\nrelieve from headaches/migraines\nrelieve muscle cramps and joint pain\nmanufacturing and supporting protein, bone, and DNA health\n*Safe for pregnant women's achy legs\n",
  tags: [],
  msrpDollars: 26.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:40.310Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
